import { render, staticRenderFns } from "./create-inspect-btn.vue?vue&type=template&id=77c7144e&"
import script from "./create-inspect-btn.vue?vue&type=script&lang=js&"
export * from "./create-inspect-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports